// extracted by mini-css-extract-plugin
export default {"dialog":"Dialog_dialog__w8c53","overlay":"Dialog_overlay__qFBET","content":"Dialog_content__1X+rT","close":"Dialog_close__+eR33","icon":"Dialog_icon__Ab4GM"};